import React from 'react';
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { PaletteCustomColors } from '@/core/theme/theme.types';

declare module '@mui/material/styles' {
  interface Palette {
    custom: PaletteCustomColors;
  }
  interface PaletteOptions {
    custom: PaletteCustomColors;
  }
  interface Theme {
    nav: {
      width: { default: string; collapsed: string };
    };
    app: {
      maxWidth: string;
    };
  }
  interface ThemeOptions {
    nav: {
      width: {
        default: string;
        collapsed: string;
      };
    };
    app: {
      maxWidth: string;
    };
  }
}

const warningYellow = '#eed202';
export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 835,
      lg: 1440,
      xl: 1536,
    },
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#007F6E',
    },
    secondary: {
      main: '#003057',
    },
    text: {
      primary: '#003057',
      secondary: '#59758B',
    },
    info: {
      main: '#0060A1',
    },
    custom: {
      darkGrey: '#54565A',
      lightGrey: '#D9D8D6',
      primaryGreen: '#00A887',
      primaryBlue: '#003057',
      primaryDark: '#00584D',
      secondaryGreen: '#007F6E',
      secondaryBlue: '#0060A1',
      background: '#F4F8F9',
      errorFill: '#FBEAEA',
      warningLight: '#FDF0E6',
      errorContent: '#541313',
      warningYellow,
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: {
      fontSize: '3.051875rem',
      letterSpacing: '-1.5px',
    },
    h2: {
      fontSize: '2.44125rem',
    },
    h3: {
      fontSize: '1.953125rem',
    },
    h4: {
      fontSize: '1.5625rem',
    },
    h5: {
      fontSize: '1.25rem',
    },
    subtitle1: {
      letterSpacing: '0.15px',
    },
    h6: {
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.125rem',
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        sizeLarge: {
          letterSpacing: '0.46px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: grey['700'],
        },
      },
    },
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: <WarningAmberIcon fontSize="small" />,
        },
      },
      styleOverrides: {
        filledInfo: {
          background: warningYellow,
          color: '#003057',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 400 500;
          src: url(/assets/Inter.variable.woff2) format('woff2');
        }
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          font-weight: 600;
          src: url(/assets/Inter.variable.woff2) format('woff2');
        }
      `,
    },
  },
  nav: {
    width: {
      default: '249px',
      collapsed: '65px',
    },
  },
  app: {
    maxWidth: '1920px',
  },
});
